import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutSelectStopsPrompt extends Layout {
    buttonCancel: Button;
    buttonClose: Button;
    buttonRevert: Button;
    horizontalspacer4: HorizontalSpacer;
    labelHelperText: Label;
    labelTitle: Label;
    panelButtons: Panel;
    panelHeader: Panel;
    panelMainContent: Panel;
    sourceStop: DataSource;
    tableSelectStops: Table;
}
